<sui-dialog-tabs>
  <ng-template suiDialogLeftHeader>
    <h2 ngpDialogTitle>{{ actionTitle }}</h2>
  </ng-template>

  <ng-template suiDialogLeftContent>
    <app-search-input
      [placeholder]="'widget-settings-popup.search.search' | translate"
      (inputChanged)="onSearchInput($event)"
    ></app-search-input>

    <app-dialog-tab-nav
      [tabs]="visibleTabs"
      [activeId]="tabManager.activeTabId()"
      [invalidIds]="visibleInvalidTabIds"
      [invalidCounts]="visibleInvalidFieldCounts"
      (tabSelect)="tabManager.selectTab($event)"
    />
  </ng-template>

  <ng-template suiDialogRightHeader>
    <div class="right-header-content">
      <h2 ngpDialogDescription>{{ objectTitle }}</h2>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogRightContent>
    <ng-container #tabHost></ng-container>
  </ng-template>

  <ng-template suiDialogRightFooter>
    @if (!isCustomRecord) {
      <sui-button variant="secondary" (click)="saveAsCustom()">
        {{ "btn.save-as-custom" | translate }}
      </sui-button>
    }
    <sui-button
      variant="primary"
      [disabled]="!canSaveAsNew()"
      [suiTooltip]="
        canSaveAsNew()
          ? undefined
          : ('output-settings.tooltip.enter-a-new-name-to-save-as-new'
            | translate)
      "
      (click)="saveAsNew()"
    >
      {{ "btn.save-as-new" | translate }}
    </sui-button>
    <sui-button variant="danger" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button variant="primary" (click)="editSettings()">
      {{ "btn.update" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-tabs>
